import printHtml from '@/mixins/printHtml'

const printBOL = {
  mixins: [printHtml],
  methods: {
    /*
      bol : {shipperName, shipperAddress, shipToAddress, referenceNumber, date, shipVia, pallets, specialInstructions, laa,
             lines: {sku, description, quantity, precision, units, weight}}
    */
    printBOL(bol) {
      const lines = [`
          <style>
            @page {size:portrait}
            .bol {font-family: Roboto, sans-serif;font-size:14px;width:100%;border-spacing:0;text-align:left;border-collapse:collapse;table-layout:fixed}
            .bol th {font-weight:normal;vertical-align:top;padding:8px 8px;border:thin solid black}
            .bol .heading {font-size:10px;font-weight:bold;margin-bottom:5px}
            .bol .title {text-align:center;font-size:16px;font-weight:bold;border:none}
            .bol td {padding:8px 8px}
            .bol .right {text-align:right}
            .bol .border {border:thin solid black;padding:10px}
            .bol .border-left {border-left:thin solid black}
            .bol .border-right {border-right:thin solid black}
            .b60 {background-color:#ccc}
            .diagonal-status {
              position:absolute;
              font-size:200px;
              opacity:0.2;
              transform: rotate(-45deg);
              -ms-transform: rotate(-45deg);
              -webkit-transform: rotate(-45deg);
              left:50px;
              top:300px;
              pointer-events: none;
              z-index:100	;
            }
          </style>
          <table class="bol">
            <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
            <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
            <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
            <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
            <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
            <thead>
              <tr><th colspan="20" class="title">STRAIGHT BILL OF LADING</th></tr>
              <tr>
                <th colspan="10" rowspan="3" class="border" height="110">
                  <div class="heading">SHIPPER</div>
                  <div>${bol.shipperName}<br/>${bol.shipperAddress.replace(/\n/gi,'<br/>')}</div>
                </th>
                <th colspan="5">
                  <div class="heading">REFERENCE NUMBER</div>
                  <div>${bol.referenceNumber}</div>
                </th>
                <th colspan="5">
                  <div class="heading">SHIPPING DATE</div>
                  <div>${this.$formatDate(bol.date)}</div>
                </th>
              </tr>
              <tr>
                <th colspan="10">
                  <div class="heading">CARRIER</div>
                  <div>${bol.shipVia || '&nbsp;'}</div>
                </th>
              </tr>
              <tr>
                <th colspan="10" rowspan="2">
                  <div class="heading">SPECIAL INSTRUCTIONS</div>
                  <div>${bol.specialInstructions}</div>
                </th>
              </tr>
              <tr>
                <th colspan="10" class="border" height="110">
                  <div class="heading">CONSIGNEE</div>
                  <div>${bol.shipToAddress.replace(/\n/gi,'<br/>')}</div>
                </th>
              </tr>

              <tr>
                <th colspan="3" class="heading">ITEM</th>
                <th colspan="11" class="heading">DESCRIPTION</th>
                <th colspan="3" class="heading right">QTY</th>
                <th colspan="3" class="heading right">WEIGHT</th>
              </tr>
            </thead>
            <tbody>`];
      let total = 0;
      bol.lines.forEach(line => {
        total += line.weight;
        lines.push(`<tr>
                      <td colspan="3">${line.sku}</td>
                      <td colspan="11">${line.description}${line.lot?`<br/>Lot ${line.lot}`:''}</td>
                      <td colspan="3" class="right">${this.$number(line.quantity, line.precision)} ${line.units}</td>
                      <td colspan="3" class="right">${this.$number(line.weight, 3)} kg</td>
                    </tr>`);
      });
      lines.push(`<tr>
                    <td colspan="10" class="border" style="border-right:none">${bol.pallets ? `Total skids: ${bol.pallets}` : ''}</td>
                    <td colspan="10" class="border right" style="border-left:none">${this.$number(total, 3)} kg</td>
                  </tr>`)
      if (bol.laa)
        lines.push(`<tr class="b60">
                      <th colspan="20" class="border" style="border-bottom:none">
                        <div><strong>B60 INFORMATION</strong></div>
                        <div><strong>CONSIGNEE, PLEASE COMPLETE, SIGN AND RETURN TO ${bol.shipperName}</strong></div>
                      </th>
                    </tr>
                    <tr class="b60">
                      <th colspan="6" style="border-right:none;border-top:none">
                        <strong>Total LAA:</strong> ${this.$number(bol.laa, 3)}
                      </th>
                      <th colspan="6" style="border-right:none;border-left:none;border-top:none">
                        <strong>LAA received:</strong>
                      </th>
                      <th colspan="8" style="border-left:none;border-top:none" height="40">
                        <strong>Signature:</strong>
                      </th>
                    </tr>`);
      lines.push(`<tr>
                    <td colspan="10" class="border">
                      <div class="heading">SHIPPER</div>
                      <div>PER ${bol.shipperName}</div>
                      <div class="heading right" style="margin-top:20px">Signature</div>
                    </td>
                    <td colspan="10" class="border">
                      <div class="heading">CARRIER</div>
                      <div>PER ${bol.shipVia}</div>
                      <div class="heading right" style="margin-top:20px">Signature</div>
                    </td>
                  </tr>
                  </tbody>
                </table>`)

      this.printHtml(`BOL ${bol.referenceNumber}`, lines.join(''));
    }
  }
}

export default printBOL;